import React, { useState } from 'react';
import styled from 'styled-components';
import { Row, Cell } from './StyledTable';
import { isUndefined, notUndefined } from '../../../lib/typeCheck';
import { Toggle } from '../../common/fields/devices/Toggle';
import { ScheduleReportSelect } from './selectors/ScheduleReportSelect';
import { DateTime } from 'luxon';
import { Icon } from '@iconify/react';
import documentPdf from '@iconify/icons-carbon/document-pdf';
import { ResolvedReportScheduleSlice, ReportTemplateSlice } from '../../../store/data-export/types';

const getRecipientsShortString = (recipients) => {
  
  if (isUndefined(recipients) || recipients.length === 0) return '';
  
  // Create a string of all first names
  let firstNames = recipients
    .map(recipient => notUndefined(recipient.first_name)? recipient.first_name : '')
    .filter(str => str.length > 0)
    .join(', ');
  
  // Trim to limit
  const limit = 20;
  return firstNames.length > limit? firstNames.slice(0, limit) + '...' : firstNames;
}

const CenteredToggle = styled.div`
  margin: 0 auto;
  display: flex;
  justify-content: center;
`;

const ClickContainer = styled.div`
  cursor: pointer;
`;

const Title = styled.div`
  padding: 5px;
  font-size: 15px;
`;

const Date = styled.div`
  padding: 5px;
  font-size: 12px;
`;

export const ScheduleRow = ({ schedule, reportTemplates }: { schedule: ResolvedReportScheduleSlice; reportTemplates: ReportTemplateSlice[] }) => {
  // console.log(schedule)
  
  const [displaySelect, setDisplaySelect] = useState(false);
  
  return (
    <Row key={schedule.id}>
      <Cell>{schedule.resolvedTemplate.format ==='pdf'? <Icon icon={documentPdf} width={30}/> : null}</Cell>
      <Cell>
        <ClickContainer onClick={() => { setDisplaySelect(!displaySelect) }}>
          <Title>{schedule.resolvedTemplate.title}</Title>
          <Date>Next Run: {DateTime.fromSQL(schedule.created).toFormat('dd LLL - hh:mm') + (schedule.resolvedSchedule === null? ' (Manual)' : '')}</Date>
        </ClickContainer>
        {displaySelect && <ScheduleReportSelect schedule={schedule} reportTemplates={reportTemplates}/>}
      </Cell>
      <Cell>{schedule.resolvedMenuNode.label}</Cell>
      <Cell centered={true}>-</Cell>
      <Cell centered={true}>{getRecipientsShortString(schedule.resolvedRecipients)}</Cell>
      <Cell><CenteredToggle><Toggle selected={schedule.active.toString() == '1'}/></CenteredToggle></Cell>
      <Cell>Actions</Cell>
    </Row>
  )
}